import React from 'react';
import { Text, View, TouchableOpacity, StyleSheet } from 'react-native';
import CS from '../constants/Styles';
import Colors from '../constants/Colors';

const YesNoToggle = (props) => {

  const yes = () => {
    props.setValue(true);
    change(true);
  }
  const no = () => {
    props.setValue(false);
    change(false);
  }
  const change = (value) => {
    if (props.onChange && typeof props.onChange === 'function') {
      props.onChange(value);
    }
  }

  return (
    <View style={CS.rowContainer}>
      <Text style={[CS.smallText, CS.lightText, styles.text]}>{props.text}</Text>
      <View style={[CS.rowContainer, styles.tabButtons]}>
        <TouchableOpacity onPress={yes}>
          <View style={[styles.tabButtonContainer, styles.left, (props.value && styles.tabButtonContainerActive)]}>
            <Text style={[styles.tabButton, CS.boldText, (props.value && styles.tabButtonActive)]}>Yes</Text>
          </View>
        </TouchableOpacity>
        <TouchableOpacity onPress={no}>
          <View style={[styles.tabButtonContainer, styles.right, (!props.value && styles.tabButtonContainerActive)]}>
            <Text style={[styles.tabButton, CS.boldText, (!props.value && styles.tabButtonActive)]}>No</Text>
          </View>
        </TouchableOpacity>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  text: {
    textAlign: 'right',
    flex: 1,
    marginRight: 10,
  },
  tabButtons: {
    marginLeft: 'auto',
  },
  tabButtonContainer: {
    paddingVertical: 10,
    paddingHorizontal: 30,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: Colors.lightBlue,
  },
  tabButtonContainerActive: {
    backgroundColor: Colors.yellow,
    borderColor: Colors.yellow,
  },
  tabButton: {
    color: Colors.lightText,
    textAlign: 'center',
    fontSize: 20,
  },
  tabButtonActive: {
    color: Colors.darkText,
  },
  left: {
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
  },
  right: {
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
  },
});

export default YesNoToggle;